// 分类/标签配色映射（tone: primary | secondary | accent）
export const toneBadge: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  secondary: "bg-secondary-100 text-secondary-900",
  accent: "bg-accent-100 text-accent-900",
};

export const toneSolid: Record<string, string> = {
  primary: "bg-primary-500 text-background-50",
  secondary: "bg-secondary-400 text-foreground-950",
  accent: "bg-accent-500 text-background-50",
};

export const toneSoft: Record<string, string> = {
  primary: "bg-primary-500/10 text-primary-600 ring-primary-200",
  secondary: "bg-secondary-500/15 text-secondary-900 ring-secondary-200",
  accent: "bg-accent-500/10 text-accent-700 ring-accent-200",
};

export const toneDot: Record<string, string> = {
  primary: "bg-primary-500",
  secondary: "bg-secondary-500",
  accent: "bg-accent-500",
};